import { render, staticRenderFns } from "./AddBlockedBranch.vue?vue&type=template&id=25c8aad6"
import script from "./AddBlockedBranch.vue?vue&type=script&lang=js"
export * from "./AddBlockedBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports